/* eslint-disable import/extensions,import/no-unresolved,import/no-duplicates,import/no-named-as-default-member */

import { createSelector } from 'reselect';
import { mapWithDefault } from 'utils/dataMapper';

const selectClaims = (state) => state.get('claims');

const makeSelectClaimList = () =>
  createSelector(selectClaims, (state) => state.get('claims'));

const makeSelectClaimId = () =>
  createSelector(selectClaims, (state) =>
    mapWithDefault(state, () => state.get('selectedClaimId'), ''),
  );

const makeSelectClaimNumber = () =>
  createSelector(selectClaims, (state) =>
    mapWithDefault(state, () => state.get('selectedClaimNumber'), ''),
  );

const makeSelectSubmitted = () =>
  createSelector(selectClaims, (state) => state.get('submitted'));

const makeSelectClaimTypes = () =>
  createSelector(selectClaims, (state) =>
    mapWithDefault(state, () => state.get('claimTypes').toJS(), ''),
  );

const makeSelectLoadingStatus = () =>
  createSelector(selectClaims, (state) => state.get('loading'));

const makeSelectPolicyTypeId = () =>
  createSelector(selectClaims, (state) => state.get('policyTypeId'));

const makeSelectTitleList = () =>
  createSelector(selectClaims, (state) => state.get('titleList'));

const makeSelectDepreciationTypes = () =>
  createSelector(selectClaims, (state) => state.get('depreciationTypes'));

const makeSelectClaimNumbers = () =>
  createSelector(selectClaims, (state) => state.get('selectedClaimNumbers'));

export {
  selectClaims,
  makeSelectClaimList,
  makeSelectClaimId,
  makeSelectSubmitted,
  makeSelectClaimTypes,
  makeSelectLoadingStatus,
  makeSelectClaimNumber,
  makeSelectPolicyTypeId,
  makeSelectTitleList,
  makeSelectClaimNumbers,
  makeSelectDepreciationTypes,
};



// WEBPACK FOOTER //
// ./app/containers/ClaimList/selectors.js